<template>
  <p v-if="isPrint" class="print-input">{{ timeRang.sTime }} ~ {{ timeRang.eTime }}</p>
  <div v-else class="time">
    <time-selector v-model="timeRang.sTime" :readonly="readonly" :maxTime="timeRang.eTime" :class="readonly && 'date-readonly'" />
    <p>~</p>
    <time-selector v-model="timeRang.eTime" :readonly="readonly" :minTime="timeRang.sTime" :class="readonly && 'date-readonly'" />
  </div>
</template>

<script>
import TimeSelector from "@/components/selector/TimeSelector.vue";

export default {
  components: {
    TimeSelector,
  },
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    value: { type: Object | String, default: () => ({ sTime: "", eTime: "" }) },
  },
  data() {
    return {
      timeRang: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.timeRang = value;
      },
    },
    timeRang: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
        this.$emit("sTime", value.sTime);
        this.$emit("eTime", value.eTime);
      },
    },
  },
  created() {
    if (typeof this.value === "string") {
      this.timeRang = { sTime: "", eTime: "" };
    }
  },
};
</script>
<style lang="scss" scoped>
.date-readonly::v-deep {
  .vsinput input {
    background: #fafafa;
  }
}
</style>
